<template>
	<tr>
		<!-- TODO: clean up this mess with v-show -->
		<td class="text-truncate" v-show="isColumnEnabled[0]">
			{{ sitemapPathname }}
		</td>
		<td class="text-center" v-show="isColumnEnabled[1]">
			{{ result.robots }}
		</td>
		<td class="text-center" v-show="isColumnEnabled[2]">
			{{ result.ads ? "yes" : "no" }}
		</td>
		<td :class="['text-end', statusClass]" v-show="isColumnEnabled[3]">
			{{ result.status }}
		</td>
		<td :class="['text-end', durationClass]" v-show="isColumnEnabled[4]">
			{{ result.durationMS / 1000 }}
		</td>
		<td class="text-truncate" v-show="isColumnEnabled[5]">
			<a
				class="link-secondary"
				:href="result.url"
				target="_blank"
				rel="noopener noreferrer"
				>{{ pathname }}</a
			>
		</td>
		<td class="text-truncate" v-show="isColumnEnabled[6]">
			{{ result.caption }}
		</td>
		<td class="text-truncate" v-show="isColumnEnabled[7]">
			{{ result.title }}
		</td>
		<td :class="['text-end', descriptionClass]" v-show="isColumnEnabled[8]">
			{{ result.description?.length }}
		</td>
	</tr>
</template>

<script lang="ts">
import { Result } from "@/services/watcherService";
import { getPathname, isErrorStatusCode } from "@/utils";
import { computed, defineComponent, toRefs } from "vue";

export default defineComponent({
	props: {
		result: {
			type: Object as () => Result,
			required: true,
		},
		showFullDomain: {
			type: Boolean,
			default: false,
		},
		columnsBitmask: {
			type: Array as () => boolean[],
			default: null,
		},
	},
	setup(props) {
		const { result, showFullDomain, columnsBitmask } = toRefs(props);

		const sitemapPathname = computed(() =>
			showFullDomain.value
				? result.value.sitemap
				: getPathname(result.value.sitemap)
		);
		const pathname = computed(() =>
			showFullDomain.value
				? result.value.url
				: getPathname(result.value.url)
		);

		const statusClass = isErrorStatusCode(result.value.status)
			? "table-danger"
			: "table-success";

		let durationClass = "";
		if (1000 <= result.value.durationMS && result.value.durationMS < 1500) {
			durationClass = "table-warning";
		} else if (1500 <= result.value.durationMS) {
			durationClass = "table-danger";
		}

		let descriptionClass = "";
		if (result.value.description !== null) {
			const descriptionLength = result.value.description.length;
			if (descriptionLength < 50 || descriptionLength > 300) {
				descriptionClass = "table-danger";
			} else if (descriptionLength < 140 || descriptionLength > 180) {
				descriptionClass = "table-warning";
			}
		}

		return {
			sitemapPathname,
			pathname,
			isColumnEnabled: columnsBitmask,
			statusClass,
			durationClass,
			descriptionClass,
		};
	},
});
</script>
